import React from "react";

const Categories = ({ 
  CateclassName, 
  disabled, 
  bgColor, 
  onClick, 
  iconlayout, 
  btnIconlayout, 
  btnIcon, 
  btnTitle, 
  comingSoon, 
  fontClassname 
}) => {
  return (
    <button
      className={`${CateclassName} transition-all duration-200 ${
        disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer active:scale-95"
      }`}
      // style={{ backgroundColor: bgColor }} // Injected color from CategoriesBtnColor
      onClick={() => (!disabled && onClick ? onClick() : null)}
      type="button"
      disabled={disabled}
    >
      <div className={`relative flex items-center justify-center shrink-0 ${iconlayout}`}>
        <img
          className={`w-full h-full object-contain ${btnIconlayout}`}
          src={btnIcon}
          alt={btnTitle}
        />
      </div>

      {comingSoon && (
        <div className="absolute top-0 right-0 px-2 py-0.5 rounded-tr-md rounded-bl-md shadow-sm bg-accepted">
          <p className={`${fontClassname} text-primary text-[8px] leading-tight`}>
            {comingSoon}
          </p>
        </div>
      )}

      <div className="relative z-5 overflow-hidden">
        <p className={`${fontClassname} text-secondary truncate text-left`}>
          {btnTitle}
        </p>
      </div>
    </button>
  );
};

export default Categories;